// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__2c_Fj","buttons":"Footer_buttons__v3RUO"};